/**
 * „Du bist hier" an einem Knopf, der sonst genau hierher führt.
 *
 * Martins Regel vom 27.08.: „NIE ein Knopf, der dorthin führt, wo man schon
 * steht." Wo ein solcher Knopf ohnehin dasteht (die Symbolleiste mit Zuhause
 * und Chat, seit 29.09. auch der Einstellungs-Knopf der Anruf-Fußzeile in den
 * Einstellungen), wird der Ort ruhig markiert, und der Knopf ist nicht mehr
 * anzutippen.
 *
 * EINE Schreibweise für diesen Zustand (22.09.: eine zweite war schon gebaut
 * und gemessen unsichtbar):
 *   data-active   daran hängt das Aussehen (style.css)
 *   aria-current  das sagt der Bildschirmleser („aktuelle Seite")
 *   disabled      ein Tipp tut nichts — auch nicht die offene Seite neu bauen
 *
 * Eigenes Modul, damit das VERHALTEN prüfbar ist: app.ts lässt sich im Test
 * nicht starten.
 */
export function setzeOrtMarke(
  knopf: HTMLButtonElement | null,
  hier: boolean,
): void {
  if (!knopf) return;
  knopf.dataset.active = hier ? "true" : "false";
  knopf.setAttribute("aria-current", hier ? "page" : "false");
  knopf.disabled = hier;
}

/** Vollseiten, die über einer Ansicht liegen können (dieselbe Gruppe wie die Vollseiten in style.css). */
const VOLLSEITEN =
  ".page-sheet, .hd-overlay, .book-overlay, .archive-overlay, .usr-overlay, .changelog-sheet, .tickets-backdrop, .project-sheet-overlay--full";

/** Liegt gerade eine Vollseite über der Ansicht? Dann ist man nicht „in" Chat oder Zuhause. */
export function vollseiteOffen(doc: Document): boolean {
  return [...doc.querySelectorAll<HTMLElement>(VOLLSEITEN)].some((e) => !e.hidden);
}

/**
 * Die Ortsmarke des Umschalters in der Kopfzeile (Telefon). Dieselben Zeichen wie bei `setzeOrtMarke`
 * (data-active, aria-current) — aber der Knopf bleibt antippbar: liegt eine Vollseite über dem Chat, ist der Chat
 * nicht „hier", und ein Tipp muss die Seite schließen.
 */
export function setzeKopfOrtMarke(knopf: HTMLButtonElement | null, hier: boolean, doc: Document): void {
  if (!knopf) return;
  const echt = hier && !vollseiteOffen(doc);
  knopf.dataset.active = echt ? "true" : "false";
  knopf.setAttribute("aria-current", echt ? "page" : "false");
}
